import React, {Component} from 'react';
import DefaultModal from "../../accounting/invoice/DefaultModal";
import {Col, FormGroup, Input, Label} from "reactstrap";
import {isValidSendMail} from "../../common/componentValidation";
import {showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import Alert from 'react-s-alert';
import '../../local_node_modules/react-select/dist/react-select.css';
import Select from"../../local_node_modules/react-select"
import {VirtualHost} from "../../constants";
import moment from "moment/moment";

class SendInvoiceMailModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			sendBtnDisabled: false,
			btnDisabled: false,
			mailModal: false,
			mailProperty: -1,
			mailProperties: [],
			corporateMail: '',
			receiver: '',
			toMail: '',
			ownerCustomer: null
		};
		this.confirmSendMail = this.confirmSendMail.bind(this);
		this.getInvoiceMail = this.getInvoiceMail.bind(this);
		this.getEmailByVkntckn = this.getEmailByVkntckn.bind(this);
	}

	componentDidMount() {
		this.setState({
			selected: this.props.selected,
			mailModal: this.props.mailModal,
			isSendPDF: true,
			isSendXML: (this.props.type !== "SERBESTMESLEKMAKBUZ" && this.props.type !== "eBelge")
		});

		let self = this;

		let params = {
			url: `/mail/getMailProperties`,
			method: "post"
		};
		request(params)
			.then(function (response) {
				let mailProperties = response.data;
				let mailProperty = -1;
				let ownerCustomer = null;
				if (mailProperties.length > 0) {
					mailProperty = mailProperties[0].recordId;
					ownerCustomer = mailProperties[0].customerId;
				}
				self.setState({ mailProperties, mailProperty, ownerCustomer }, () => {
					if (self.props.type === "progressPaymentHakedis") {
						let vkntckn = self.props.selected?.distributor?.vknTckn;
						if (vkntckn) {
							self.getEmailByVkntckn(vkntckn);
						}
					} else {
						let vkntckn = ["inbox", "despatchInbox"].includes(self.props.type) ? self.props.selected?.sourceId : self.props.selected?.destinationId;
						if (vkntckn) {
							self.getEmailByVkntckn(vkntckn);
						}
					}
				});
			}).catch(function (error) {
			showAxiosError(error);
		});

		let subject = "";
		if (VirtualHost.conf.resourcePrefix === "zirve") {
			let title = ["inbox", "despatchInbox"].includes(this.props.type) ? this.props.selected.sourceTitle : this.props.selected.destinationTitle;
			let vknTckn = ["inbox", "despatchInbox"].includes(this.props.type) ? this.props.selected.sourceId : this.props.selected.destinationId;
			if (vknTckn.length === 10 && title.length > 30) {
				subject = title.substr(0, 29) + " " + this.props.selected.documentId;
			} else {
				subject = title + " " + this.props.selected.documentId;
			}
		} else {
			subject = this.props.selected.documentId;
		}
		if (this.props.type === "progressPaymentHakedis") {
			subject = this.props.selected.distributor.vknTckn + "_" + moment(this.props.selected?.startDate).format("YYYY") + "-" + moment(this.props.selected?.startDate).format("MM");
		}
		if (this.props.type === "progressPaymentHakedis") {
			let receiver = this.props.selected.distributor.customerName;
			let toMail = this.props.selected.distributor.corporateMail;
			this.setState({ receiver: receiver, toMail: toMail });
		} else {
			let receiver = ["inbox", "despatchInbox"].includes(this.props.type) ? this.props.selected.sourceTitle : this.props.selected.destinationTitle;
			this.setState({ receiver: receiver });
		}

		switch (this.props.type) {
			case "archiveInvoice":
				subject += " nolu e-Arşiv Faturanız";
				break;
			case "despatchInbox":
			case "despatchOutbox":
				subject += " nolu e-İrsaliyeniz";
				break;

			case "inbox":
			case "outbox":
				subject += " nolu e-Faturanız";
				break;
			case "eBelge":
				subject += " nolu e-Arşiv Belgeniz";
				break;
			case "SERBESTMESLEKMAKBUZ":
				subject += " nolu e-Serbest Meslek Makbuzunuz";
				break;
			case "MUSTAHSILMAKBUZ":
				subject += " nolu e-Müstahsil Makbuzunuz";
				break;
			case "expenseNote":
				subject += " nolu e-Gider Pusulanız";
				break;
			case "ADISYON":
				subject += " nolu e-Adisyon Belgeniz";
				break;
			case "Exchange":
				subject += " nolu e-Döviz Belgeniz";
				break;
			case "progressPaymentHakedis":
				subject += " Dönemi Hakediş Faturaları Hk.";
				break;
			case "SIGORTA":
				subject += " nolu e-Sigorta Belgeniz";
				break;
		}
		this.setState({ subject: subject });

		if (this.props.type === "progressPaymentHakedis") {
			let receiver = "";
			let toMail = "";
			receiver = this.props.selected.distributor.customerName;
			toMail = this.props.selected.distributor.corporateMail;
			this.setState({ receiver: receiver, toMail: toMail });
		}
	}

	getEmailByVkntckn(vkntckn) {
		let params = {
			url: `/externalCustomer/get-email`,
			method: "get",
			params: {
				vkntckn: vkntckn,
				ownerCustomer: this.state.ownerCustomer
			}
		};
		request(params)
			.then((response) => {
				this.setState({ toMail: response.data });
			}).catch((error) => {
			if (error.response && error.response.status === 400) {
				Alert.error(error.response.data, {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 2000
				});
			} else {
				showAxiosError(error);
			}
		});
	}

	getInvoiceMail() {
		let self = this;
		let editUrl = "";
		switch (this.props.type) {
			case "archiveInvoice":
				editUrl = `/eArchive/getInvoiceMail`;
				break;
			case "outbox":
				editUrl = `/outbox/getInvoiceMail`;
				break;
		}
		let params = {
			url: editUrl,
			method: "post",
			data: self.state.selected.documentUuid
		};
		self.setState({ btnDisabled: true });
		request(params)
			.then(function (response) {
				self.setState({ toMail: response.data, btnDisabled: false });
			}).catch(function (error) {
			showAxiosError(error);
			self.setState({ btnDisabled: false });
		});
	}

	confirmSendMail() {
		let self = this;
		let formData = {
			mailProperty: self.state.mailProperty,
			recordId: self.state.selected.recordId,
			receiver: self.state.receiver,
			subject: self.state.subject,
			isSendPDF: self.state.isSendPDF,
			isSendXML: self.state.isSendXML,
			toMail: self.state.toMail,
			type: self.props.type,
			year: self.props.year && self.props.year,
			month: self.props.month && self.props.month,
			date: self.state.selected.documentIssueDate,
			documentUuid: self.state.selected.documentUuid,
			host: window.location.origin,
			identifier: null
		};

		let type = self.props.type;

		if (["inbox", "outbox", "archiveInvoice"].includes(this.props.type)) {
			if (type === 'inbox') {
				formData["vknTckn"] = self.props.selected.destinationId;
			} else {
				formData["vknTckn"] = self.state.selected.sourceId;
			}
		}
		if (self.props.type === "progressPaymentHakedis") {
			formData["identifier"] = self.props.selected?.distributor?.vknTckn;
		}
		let result = isValidSendMail(formData);
		let valid = result.valid;
		if (valid) {
			let params = {
				url: self.props.postUrl,
				method: "post",
				data: formData
			};
			self.setState({ sendBtnDisabled: true });
			request(params)
				.then((response) => {
					Alert.success(response.data, {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 2000
					});
					self.setState({ selected: null, mailModal: false });
					self.props.toggleModal(false);
					if (self.props.fetchData) {
						self.props.fetchData();
					}
				}).catch(function (error) {
				showAxiosError(error);
			}).then(function () {
				self.setState({ sendBtnDisabled: false });
			});
		} else {
			Alert.error(result.errorMessage, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 2000
			});
			self.setState({ sendBtnDisabled: false });
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.selected !== nextProps.selected || this.props.mailModal !== nextProps.mailModal) {
			this.setState({ selected: nextProps.selected, mailModal: nextProps.mailModal });

			if (nextProps.type === "progressPaymentHakedis") {
				let vkntckn = nextProps.selected?.distributor?.vknTckn;
				if (vkntckn) {
					this.getEmailByVkntckn(vkntckn);
				}
			} else {
				let vkntckn = ["inbox", "despatchInbox"].includes(nextProps.type) ? nextProps.selected?.sourceId : nextProps.selected?.destinationId;
				if (vkntckn) {
					this.getEmailByVkntckn(vkntckn);
				}
			}

			if (nextProps.type === "progressPaymentHakedis") {
				let receiver = nextProps.selected.distributor.customerName;
				let toMail = nextProps.selected.distributor.corporateMail;
				this.setState({ receiver: receiver, toMail: toMail });
			} else {
				let receiver = ["inbox", "despatchInbox"].includes(nextProps.type) ? nextProps.selected.sourceTitle : nextProps.selected.destinationTitle;
				this.setState({ receiver: receiver });
			}
		}
	}

	render() {
		return (
			<DefaultModal disabled={this.state.sendBtnDisabled}
						  isOpen={this.state.mailModal}
						  title={this.props.type === "progressPaymentHakedis" ? this.state.selected && ("E-Posta Gönderimi ( " + this.props.selected.distributor.vknTckn + " )") : this.state.selected && ("E-Posta Gönderimi ( " + this.state.selected.documentId + " )")}
						  confirmBtnText="Gönder"
						  cancelBtnText="Kapat"
						  onConfirm={() => this.confirmSendMail()}
						  onCancel={(e) => this.setState({ mailModal: false, sendBtnDisabled: false }, () => {
							  this.props.toggleModal(false);
						  })}
			>
				{(this.props.type === "archiveInvoice" || this.props.type === "outbox") &&
					<FormGroup row>
						<Col sm={12}>
							<button className="btn btn-sm pull-right"
									style={{
										padding: "0px 9px 0px 9px",
										margin: "0px",
										backgroundColor: "inherit",
										color: "#78b1d7"
									}}
									title="e-Posta'yı XML'den Getir"
									disabled={this.state.btnDisabled}
									onClick={this.getInvoiceMail}>
								<i className="far fa-copy" />
							</button>
						</Col>
					</FormGroup>
				}
				{this.props.type !== "progressPaymentHakedis" &&

					<FormGroup row>
						<Label sm={4}>Gön. E-Posta Adresi: *</Label>
						<Col sm={8}>
							<Select
								id="mailProperty"
								clearable={false}
								value={this.state.mailProperty}
								placeholder="Seçiniz..."
								onChange={(e) => e && this.setState({ mailProperty: e.value })}
								options={this.state.mailProperties.map(mailProperty => ({
									value: mailProperty.recordId,
									label: (mailProperty.recordId === -1 ? "Entegratör Mail Adresinden" : mailProperty.user)
								}))}
							/>
						</Col>
					</FormGroup>
				}

				<FormGroup row>
					<Label sm={this.state.type === "archiveInvoice" ? 2 : 4}>Alıcı E-Posta Adresi: *</Label>
					<Col sm={8}>
						<Input type="email" name="toMail" id="toMail" value={this.state.toMail} onChange={(e) => this.setState({ toMail: e.target.value })} disabled={this.props.type === "progressPaymentHakedis"} />
					</Col>
				</FormGroup>

				<FormGroup row>
					<Label sm={4}>Konu Başlığı *</Label>
					<Col sm={8}>
						<Input type="text" name="subject" value={this.state.subject} onChange={(e) => this.setState({ subject: e.target.value })} disabled={this.props.type === "progressPaymentHakedis"} />
					</Col>
				</FormGroup>

				<FormGroup row>
					<Label sm={4}>Alıcı Adı ve Soyadı: *</Label>
					<Col sm={8}>
						<Input type="text" name="receiver" id="receiver" value={this.state.receiver}
							   onChange={(e) => this.setState({ receiver: e.target.value })}
							   disabled={this.props.type === "progressPaymentHakedis"} />
					</Col>
				</FormGroup>

				<FormGroup row>
					<Col sm={4} />
					<Col sm={4}>
						{(this.props.type !== "SERBESTMESLEKMAKBUZ" && this.props.type !== "eBelge" && this.props.type !== "progressPaymentHakedis") &&
							<Label check>
								<Input type="checkbox" checked={this.state.isSendXML} onChange={(e) => this.setState({ isSendXML: e.target.checked })} />{' '}
								XML
							</Label>
						}
					</Col>
					<Col sm={4}>
						{this.props.type !== "progressPaymentHakedis" &&
							<Label check>
								<Input type="checkbox" checked={this.state.isSendPDF} onChange={(e) => this.setState({ isSendPDF: e.target.checked })} />{' '}
								PDF
							</Label>
						}
					</Col>
				</FormGroup>
			</DefaultModal>
		)
	}
}

export default SendInvoiceMailModal;
